"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var HomeUserFilter = function (_a) {
    var currentUserOnly = _a.currentUserOnly, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "home-user-filter flex flex-row" },
        react_1.default.createElement(Select_1.default, { name: "user-filter", value: currentUserOnly, onChange: onChange, options: [
                {
                    value: false,
                    text: "Show all queries"
                },
                {
                    value: true,
                    text: "Show my active queries"
                }
            ] })));
};
exports.default = HomeUserFilter;
